import { render, staticRenderFns } from "./SponsoredAdForm.vue?vue&type=template&id=01d96666&scoped=true&"
import script from "./SponsoredAdForm.vue?vue&type=script&lang=js&"
export * from "./SponsoredAdForm.vue?vue&type=script&lang=js&"
import style0 from "./SponsoredAdForm.vue?vue&type=style&index=0&id=01d96666&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d96666",
  null
  
)

export default component.exports